import React from 'react';

function EduExpContent(props) {
  return (
    <div className="resume-item">
      <div className="resume-head">
        <h2 className={props.title ? 'resume-title' : 'resume-no-title'}>
          {props.title}
        </h2>
        <span className="date">
          <em>{props.date}</em>
        </span>
      </div>
      <div className="resume-head">
        <h6 className={props.title ? 'resume-subtitle' : 'resume-no-title'}>
          {props.subtitle}
        </h6>
        <p>{props.location}</p>
      </div>
      {/* <ul>
        {props.content.map((value, index) => (
          <li key={index}> ‣ {value}</li>
        ))}
      </ul> */}
    </div>
  );
}

export default EduExpContent;
